import React from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

function StatusBadge({ status, isOverdue }) {
  if (isOverdue || status === 'overdue') {
    return <span className="badge-overdue">Süresi Geçmiş</span>;
  }
  if (status === 'completed') {
    return <span className="badge-completed">Tamamlandı</span>;
  }
  return <span className="badge-in-progress">Devam Ediyor</span>;
}

export default function TaskCard({ task }) {
  const navigate = useNavigate();
  const isOverdue = task.is_overdue || task.status === 'overdue';

  return (
    <div
      className={`card mb-3 cursor-pointer active:scale-[0.99] transition-transform
        ${isOverdue ? 'border-l-4 border-l-red-400' : ''}
        ${task.status === 'completed' ? 'opacity-75' : ''}
      `}
      onClick={() => navigate(`/satis/tasks/${task.id}`)}
    >
      {/* Üst satır: kod + başlık + rozet */}
      <div className="flex items-start justify-between gap-2 mb-1">
        <div className="flex-1 min-w-0">
          <span className="font-semibold text-gray-900 text-sm">
            #{task.code} {task.title}
          </span>
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          {task.subprocess_count > 0 && task.status !== 'completed' && (
            <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${
              task.completed_subprocess_count === task.subprocess_count
                ? 'bg-green-100 text-green-700'
                : 'bg-amber-100 text-amber-700'
            }`}>
              {task.completed_subprocess_count}/{task.subprocess_count}
            </span>
          )}
          <StatusBadge status={task.status} isOverdue={task.is_overdue} />
        </div>
      </div>

      {/* Kategori */}
      <p className="text-xs text-brand-500 font-medium mb-2">{task.category_name}</p>

      {/* Sorumlu & Delegasyon */}
      <div className="space-y-0.5">
        <p className="text-xs text-gray-500">
          <span className="text-gray-400">Sorumlu:</span>{' '}
          <span className="text-gray-700">{task.assignee_name}</span>
        </p>
        {/* Aktif delege (assignee'den farklı): göster */}
        {task.is_delegated && task.delegate_has_notes && task.delegated_to_name !== task.assignee_name && (
          <p className="text-xs text-amber-600">
            <span className="text-gray-400">Delege olmuş:</span>{' '}
            <span className="font-medium">{task.delegated_to_name}</span>
            {task.delegation_note ? (
              <span className="text-gray-400 font-normal"> ({task.delegation_note})</span>
            ) : null}
          </p>
        )}
        {/* Geri alındı ama önceki delege katkı yapmış */}
        {task.is_delegated && task.delegate_has_notes && task.delegated_to_name === task.assignee_name && task.previous_delegated_to_name && (
          <p className="text-xs text-amber-600">
            <span className="text-gray-400">Delege olmuş:</span>{' '}
            <span className="font-medium">{task.previous_delegated_to_name}</span>
          </p>
        )}
        {task.customer_name && (
          <p className="text-xs text-gray-500">
            <span className="text-gray-400">Müşteri:</span>{' '}
            <span className="text-gray-700">{task.customer_name}</span>
          </p>
        )}
      </div>

      {/* Tarih */}
      <p className="text-xs text-gray-400 mt-2">
        {task.deadline && (
          <>
            <span className={isOverdue ? 'text-red-500 font-medium' : ''}>
              Deadline: {format(new Date(task.deadline), 'd MMMM yyyy', { locale: tr })}
            </span>
          </>
        )}
      </p>
    </div>
  );
}
